/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Shop_Variant_Label_AriaInputs */

const vi_shop_variant_label_aria = /** @type {(inputs: Shop_Variant_Label_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nhãn loại của ${i?.sku}`)
};

/**

* @param {Shop_Variant_Label_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_label_aria = /** @type {((inputs: Shop_Variant_Label_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_Label_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_label_aria(inputs)
});